<template>
    <v-container grid-list-md fluid>
        <div class="mar10 pad20 white-background" >

            <v-layout row wrap>
                <v-flex xs12 sm10 md10 lg10 class="float-left">
                    <h2 class="success--text text-right float-left">Recommended Listening</h2>
                </v-flex> 
            </v-layout> 

            <v-card>
                <!-- Loading -->
                <v-layout row v-if="isLoadingPodcasts == true">
                    <v-flex class="text-xs-center">
                        <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
                    </v-flex>
                </v-layout>
                
                <!-- Not Found -->
                <v-layout row v-if="isLoadingPodcasts == false && (!podcasts || podcasts.length <= 0)">
                    <v-flex class="text-xs-center">
                        <h4>No podcasts found!</h4>
                    </v-flex>
                </v-layout>
                
                <!-- Results -->
                <v-flex v-if="podcasts.length > 0" class="hidden-header">

                    <v-card>
                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light></v-card-title>
                    </v-card>
 
                    <v-data-table :headers="headers" :items="podcasts" :search="search"  :pagination.sync="pagination" light>

                        <!-- Podcast List -->
                        <template slot="items" slot-scope="props">
                            
                            <v-flex xs12 class='card-items'>
                                <v-card>
                                    <v-card-text>
                                        <!-- Podcast title, image, descriptions -->
                                        <v-layout row wrap>

                                            <v-flex xs12 sm3 md3 lg3 @click="goToPodcastDetails(props.item.id)" class="pointer">
                                                <img v-if="props.item.featured_image" class="img-responsive featured-image" :src='props.item.featured_image' v-bind:alt="props.item.photo" >
                                            </v-flex>

                                            <v-flex xs12 sm9 md9 lg9>
                                                <v-layout row wrap>

                                                    
                                                    <v-flex xs12 sm12 md12 lg12>
                                                        <h1>{{ props.item.title }}  
                                                        </h1>
                                                        <h2>{{ props.item.author }}</h2>
                                                        <h3>{{ props.item.description }}</h3>
                                                        <h3><a :href="props.item.url" target="_blank">Visit Website</a></h3>
                                                        
                                                    </v-flex>

                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>

                                </v-card>
                            </v-flex>
                        </template>

                        <!-- Pagination -->
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                            From {{ pageStart }} to {{ pageStop }}
                        </template>

                        <!-- Notifications -->
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                        </v-alert>

                    </v-data-table>
                </v-flex>
            </v-card>
 
            <div class="content-body">
                <h1 class="content-title text-center">Suggest Podcasts</h1>                
                <div class="text-center bold">Podcasts are a great way to learn on the go. Share your favorite podcasts with us.</div>
                <div class="text-center">We are curating a library of helpful podcasts. When it's ready, you will be able to search and listen to member suggested podcasts here.</div>
                <iframe src="https://services.cognitoforms.com/f/u5vx8UXMRU-V5VTTzNYvcg?id=4" class="position-relative" frameborder="0" scrolling="yes" seamless="seamless" height="646" width="100%"></iframe>
            </div>

        </div>
    </v-container>
</template>

<script>
    import PodcastService from "@/services/db/PodcastService.js";
    import CONSTANT from "@/services/Constant.js";

    import TableItem from "../table-list-items/table-list-items.vue";

    export default {
        name: "Podcasts", 
        components: {
          "table-item": TableItem,
        },
        data() {
            return {
                title: "Podcasts",
                search: "", 
                pagination: {
                    page: 1,
                    rowsPerPage: -1,
                    totalItems: 0
                },
                headers: [ ],
                podcasts: [],
                isLoadingPodcasts: true
            };
        },
        created() {
            this.loadPodcasts();
        },
        methods: {
            /*
             * Method to load books
             */
            loadPodcasts() {
                this.isLoadingPodcasts = true;
                var _USER = JSON.parse(this.$store.getters.loginUser);

                PodcastService.getPodcasts(
                    _USER.userId,
                    podcasts => {
                        this.podcasts = [];
                        this.isLoadingPodcasts = false;
                        if (podcasts) {
                            podcasts.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                this.podcasts.push(_obj);
                            });
                        }
                    }
                );
            },
        },
        mounted() {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://services.cognitoforms.com/scripts/embed.js')
            document.head.appendChild(recaptchaScript)
        },         
    };
</script>   